import React from "react";
import htmlToReact from "html-to-react";
import PropTypes from "prop-types";

const htmlToReactParser = new htmlToReact.Parser();
const renderIframe = (headline, pardotUrl, iframeTitle, isLargeEnterprise) => {
  let queryParams = "";
  if (window.laDataLayer) {
    const { leadGenParam, tsrc, url } = window.laDataLayer;
    if (leadGenParam) {
      queryParams = `?${leadGenParam}`;
    }
    if (queryParams !== "" && tsrc) {
      queryParams = `${queryParams}&referrer=${tsrc.replaceAll("/", "%2F")}`;
    } else if (tsrc) {
      queryParams = "?referrer=" + tsrc.replaceAll("/", "%2F");
    }
    if(isLargeEnterprise) {
      const splitedUrl = url.split("/");
      queryParams = queryParams !== "" ? queryParams + `&description=${splitedUrl[splitedUrl.length-1]}` : `?description=${splitedUrl[splitedUrl.length-1]}`
    }
  }
  return (
    <div>
      {headline && headline.text ? (
        <div class="headSection">
          <div class="textSection">
            <h1></h1>
            <h4>
              <span>{htmlToReactParser.parse(headline.text)}</span>
            </h4>
          </div>
        </div>
      ) : null}
      <iframe
        src={`${pardotUrl}${queryParams}`}
        title={iframeTitle}
        style={{ height: "900px", width: "100%" }}
        type="text/html"
        frameBorder="0"
      />
    </div>
  );
};

export default class IframeProcessor extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loadIframe: false,
    };

    this.renderIframe = renderIframe;
    this.loadIframe = this.loadIframe.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
  }

  componentDidMount() {
    window.addEventListener('message', this.handleMessage);
    this.loadIframe();
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleMessage);
  }

  loadIframe() {
    this.setState({
      loadIframe: true,
    });
  }

  updateFrameHeight(e) {
    const { pardotUrl, iframeTitle} = this.props.content;
    const pardotDomain = pardotUrl.substring(0, pardotUrl.indexOf(".com/") + 4);
    if (pardotDomain === e.origin && e.data && e.data.frameHeight) {
      if (document.getElementsByTagName("iframe").length > 0) {
        const {
          countryCode,
          encryptedAccountNumber,
          userType
        } = this.props;

        const fpti = {dataString: window.fpti, jsURL: "https://www.paypalobjects.com", name: "pta",
          serverURL: window.fptiserverurl};
        const [iframe,] = Array.from(document.getElementsByTagName("iframe"))
            .filter( item => item.title === iframeTitle);
        // if(document.getElementsByTagName("iframe").length > 1){
        //   [,iframe] = document.getElementsByTagName("iframe");
        // } else {
        //   [iframe] = document.getElementsByTagName("iframe");
        // }
        iframe.style.height = `${e.data.frameHeight}px`;
        iframe.contentWindow.postMessage({
              fpti,
              countryCode,
              userType,
              encryptedAccountNumber,
              laDataLayer: window.laDataLayer,
          },
         e.origin
        );
      }
    }
  }

  handleMessage(e) {
    const { pardotUrl} = this.props.content;
    const pardotDomain = pardotUrl.substring(0, pardotUrl.indexOf('.com/') + 4);
    if(e.origin !==  pardotDomain ) {
      return;
    }

    this.updateFrameHeight(e);
  }
  render() {
    const { content, customStyle, isLargeEnterprise} = this.props;
    return (
      <section
        className="iframeContainer"
        style={customStyle}
      >
        {this.state.loadIframe ? (
          this.renderIframe(content.headline, content.pardotUrl, content.iframeTitle, isLargeEnterprise)
        ) : (
          <div className="loader-sec" id="loader-sec">
            <span>Loading...</span>
            <div className="loader" />
          </div>
        )}
      </section>
    );
  }
}

IframeProcessor.propTypes = {
  className: PropTypes.string,
  content: PropTypes.shape({
    pardotUrl: PropTypes.string
  }),
  countryCode: PropTypes.string,
  fpti: PropTypes.shape(),
};

IframeProcessor.defaultProps = {
  className: "",
  content: {
    pardotUrl: ""
  },
  countryCode: "US",
  fpti: {},
  userType: ""
};
